import AdminSideMenu from './AdminSideMenu';

// Export the menu width as a constant for consistency across the app
export const ADMIN_SIDE_MENU_WIDTH = 297;

export default AdminSideMenu;
